// extracted by mini-css-extract-plugin
module.exports = {"recordingItem":"browse-RecordingItem__recordingItem--2R1uq","playButton":"browse-RecordingItem__playButton--2gvja","link":"browse-RecordingItem__link--2dItk"};